import { render } from "./account.vue?vue&type=template&id=343b4775&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import "./account.vue?vue&type=style&index=0&id=343b4775&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343b4775"]])

export default __exports__